// src/styles/global.jsx
// Estilos globais NÃO relacionados a tema (cores/light-dark ficam em theme.js).
// Mantemos aqui apenas regras estruturais agnósticas ao modo de cor.
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    button {
        transition: all 0.2s ease-in-out;
    }

    .chakra-modal__content-container {
        padding-left: var(--sidebar-width, 280px) !important;
        transition: padding-left 0.3s ease-in-out;
    }
`;
